import React from 'react';

export const GardenApartmentsHero: React.FC = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b817b4b74fa7c579005761579af30a4b.jpg"
          alt="Garden Apartment Complex"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          We Buy Garden Apartments
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Fast, Fair Cash Offers for Garden Apartment Communities Across the Nation
        </p>
        <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto">
          Specializing in purchasing garden-style apartment complexes in any condition. No repairs needed, no agent commissions, close on your timeline.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#get-offer"
            className="px-8 py-4 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Get Your Cash Offer Now
          </a>
          <a
            href="#why-garden-apartments"
            className="px-8 py-4 bg-white text-gray-900 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  );
};